import { Injectable } from '@angular/core';
import { createEffect, ofType, Actions } from '@ngrx/effects';
import { mergeMap } from 'rxjs/operators';
import { CommandProgressResolverActions, CommandProgressApiActions } from './command-progress.actions';
import { MdmCommandProgressService } from '@rocksoft/mdm-sdk-v2';
import { safeMap } from '../effects.helpers';

@Injectable()
export class CommandProgressEffects {
  constructor(
    private readonly actions$: Actions,
    private readonly api: MdmCommandProgressService
  ) {}

  loadCommandProgressEffect$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(CommandProgressResolverActions.commandProgressRequested),
      mergeMap(({ udid, page }) =>
        safeMap(
          this.api.getCommandProgresses(udid, '2.0', page),
          (commandProgresses) => CommandProgressApiActions.commandProgressLoaded({ commandProgresses }),
          (error) => CommandProgressApiActions.commandProgressLoadedError({ error })
        )
      )
    );
  });
}
